import { render, staticRenderFns } from "./admin-title-new.vue?vue&type=template&id=333f9377&scoped=true"
import script from "./admin-title-new.vue?vue&type=script&lang=js"
export * from "./admin-title-new.vue?vue&type=script&lang=js"
import style0 from "./admin-title-new.vue?vue&type=style&index=0&id=333f9377&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333f9377",
  null
  
)

export default component.exports